ConfirmOnBehalfModalController.$inject = [
    "$scope",
    "modalData",
    "InterviewViewService",
    "InterviewDataService",
    "onSave"
];

function ConfirmOnBehalfModalController(
    $scope,
    modalData,
    InterviewViewService,
    InterviewDataService,
    onSave
) {
    const self = this;
    self.selectedSlot = null;
    self.timeZones = {
        brand: {
            format: null,
            offset: moment().utcOffset()
        },
        user: {
            format: null,
            offset: moment().utcOffset()
        }
    };
    const startOfWeek = 'MON';
    const viewService = InterviewViewService({
        onClick: (slot) => {
            self.selectedSlot = slot;
            $scope.$digest();
        }
    });
    self.weekRange = {};
    self.checkboxConfirmed = false;

    const init = async () => {
        try {
            self.loading = true;
            self.timeZones = modalData.timeZones;
            viewService.employeeMode = true;

            const payload = {
                interview_type: modalData.interviewType,
            }

            const data = await InterviewV2API.getEmployerInterviewSetApplication(
                modalData.brandId,
                modalData.appId,
                modalData.interviewSetId,
                payload,
            );

            self.slots = data.interview_set.slots;

            if (self.slots.length) {
                const weekStartDate = getWeekStart(moment(self.slots[0].start_time).startOf('day'), startOfWeek);
                self.weekRange.from = weekStartDate;
                self.weekRange.to = weekStartDate.clone().add(6, 'days');

                InterviewDataService.parseData(weekStartDate, self.slots);
                viewService.init(weekStartDate);
                let interviewInterval = setInterval(() => {
                    if ($('#interview-calendar-v2').length) {
                        viewService.drawAll();
                        clearInterval(interviewInterval);
                    }
                }, 100);
            }

            self.loading = false;
            $scope.$digest();
        } catch (error) {
            console.error("Failed to load interview data:", error);
        }
    };

    self.close = () => {
        $scope.$hide();
    };

    self.onWeekSelected = (weekRange) => {
        self.weekRange.from = weekRange.from;
        self.weekRange.to = weekRange.to;
        viewService.init(weekRange.from);
        viewService.drawAll();
    };

    self.confirmSelection = async () => {
        if (self.selectedSlot) {
            const payload = {
                slot_id: self.selectedSlot.id
            };
            try {
                self.confirming = true;
                await InterviewV2API.confirmInterviewOnBehalf(
                    modalData.brandId,
                    modalData.interviewSetId,
                    modalData.appId,
                    payload
                );
                onSave();
            } catch (error) {
                console.error("Failed to confirm interview:", error);
            } finally {
                self.confirming = false;
                self.close();
                $scope.$digest();
            }
        }
    };

    self.editInterviewInvite = () => {
        self.close();
        if (modalData.onEditInvite) {
            modalData.onEditInvite();
        }
    }

    init();
}

export const getConfirmOnBehalfModalController = (modalData, onSave) => {
    return {
        controller: ConfirmOnBehalfModalController,
        controllerAs: '$ctrl',
        templateUrl: '../modules/interview-v2/confirm-on-behalf-modal/confirm-on-behalf.modal.html',
        show: true,
        backdrop: false,
        resolve: {
            modalData: () => modalData,
            onSave: onSave
        }
    };
};